import { render, staticRenderFns } from "./CustomersList.vue?vue&type=template&id=a2eadb8a&"
import script from "./CustomersList.vue?vue&type=script&lang=ts&"
export * from "./CustomersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports